import simpleRestProvider from 'ra-data-simple-rest';
import {fetchUtils} from 'react-admin';
import {convertFileToBase64} from './b64toBiteArray';

const fetchJson = (url, options = {}) => {
    const api = localStorage.getItem('domain')
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    // add your own headers here
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    options.headers.set('X-COMPANY', 'ROOT');
    options.headers.set('Bypass-Tunnel-Reminder', "true");
    // console.log(api+url)
    return fetchUtils.fetchJson(api+url, options);
}


const dataProvider = simpleRestProvider(`/api`, fetchJson);

async function customUpdate(resource, params) {
    console.log({resource, params})
    if (resource === 'users') {
        let data = { ...params.data };
        if (data.signatureImage && data.signatureImage.rawFile instanceof File) {
            let base64 = await convertFileToBase64(data.signatureImage);
            if (base64.indexOf(',') !== -1) base64 = base64.split(',')[1];
            data.signatureImage = base64;
        }
        if (data.profilePicture && data.profilePicture.rawFile instanceof File) {
            let base64 = await convertFileToBase64(data.profilePicture);
            if (base64.indexOf(',') !== -1) base64 = base64.split(',')[1];
            data.profilePicture = base64;
        }
        return dataProvider.update(resource, { ...params, data });
    }
    return dataProvider.update(resource, params);
}



export default {
    ...dataProvider,
    update: customUpdate,
}
